<template>
    <footer class="main-footer">
        <strong
            >Copyright &copy; 2024
            <a href="https://planejadordetreino.com/">Planejador de Treinos</a
            >.</strong
        >
        All rights reserved. | <a href="/terms">termos de uso</a> |
        <a href="/privacy">políticas de privacidade</a>
    </footer>
</template>

<script>
export default {
    name: "FooterComponet",
};
</script>
